<template>
  <v-row class="mt-4" no-gutters>
    <v-col
      v-for="(link, index) in links"
      :key="index"
      class="pa-2"
    >
      <router-link :to="link.to">
        <v-card class="text-center pa-4" outlined link>
          <v-icon :class="link.icon" class="mb-2" style="font-size: 50px; height: 58px;" color="#222" />
          <div class="pt-0">{{ link.name }}</div>
        </v-card>
      </router-link>
    </v-col>
   
<!-- 
    <v-col class="mr-4">
      <router-link to="/asset">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-application-edit-outline mb-2" style="font-size: 50px;height: 58px;" color="#222"/>
          <v-col class="pt-0">
            VOD 관리 
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <v-col class="mr-4">
      <router-link to="/playlist">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-arrow-right-drop-circle-outline mb-2" style="font-size: 58px;" color="#222"/>
          <v-col class="pt-0">
            플레이리스트
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <v-col class="mr-4">
      <router-link to="/wowzastream/wowzalivestream_create">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-access-point mb-2" style="font-size: 58px;" color="#222"/>
          <v-col class="pt-0">
            라이브 관리
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <v-col class="mr-4">
      <router-link to="/statistics">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-chart-bar mb-2" style="font-size: 50px;height: 58px;" color="#222"/>
          <v-col class="pt-0">
            통계
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <v-col class="mr-4">
      <router-link to="/frontmg/frontmg-create">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-laptop mb-2" style="font-size: 58px;" color="#222"/>
          <v-col class="pt-0">
            템플릿
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <v-col class="mr-4">
      <router-link to="/social-upload">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-cast mb-2" style="font-size: 50px;height: 58px;" color="#222"/>
          <v-col class="pt-0">
            {{ $store.getters.t('social.history.tab.social_upload') }}
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <v-col>
      <router-link to="/admin/user">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-cog-outline mb-2" style="font-size: 58px;" color="#222"/>
          <v-col class="pt-0">
            설정
          </v-col>
        </v-card>
      </router-link>
    </v-col> -->
  </v-row>
</template>

<script>
export default {
  data(){
    return {

    }
  },
  computed: {
      vod() {
          return this.$store.state.naviList.allowList.vod;
      },
      hls() {
          return this.$store.state.naviList.allowList.hls;
      },
      webrtc() {
          return this.$store.state.naviList.allowList.webrtc;
      },
      links(){
        const links = [];

        if (this.vod) {
          links.push({ to: '/asset', name: this.$store.getters.t('VOD 관리'), icon: 'mdi mdi-application-edit-outline' });
          links.push({ to: '/playlist', name: this.$store.getters.t('플레이리스트'), icon: 'mdi mdi-arrow-right-drop-circle-outline' });
        }
        if (this.hls) {
          links.push({ to: '/wowzastream/wowzalivestream_create', name: this.$store.getters.t('라이브 관리'), icon: 'mdi mdi-access-point' });
        } else if(this.webrtc){
          links.push({ to: '/webrtc/stream_create', name: this.$store.getters.t('라이브 관리'), icon: 'mdi mdi-access-point' });
        }

        links.push({ to: '/statistics', name: this.$store.getters.t('통계'), icon: 'mdi mdi-chart-bar' });
        links.push({ to: '/admin/user', name: this.$store.getters.t('설정'), icon: 'mdi mdi-cog-outline' });


        return links;
      }
    },
  }
</script>

<style lang="scss" scoped>
.link-row {
  display: flex;
  gap: 16px; 
  // flex-wrap: nowrap;
  align-items: center;
}
</style>
